import React from "react";
import {TextBox} from "devextreme-react/text-box";

export interface IProps {
    type: "string" | "number" | "date" | "boolean";
    fieldName: string;
    caption?: string;
}

export const NFLookupEntityColumn = ({caption, fieldName, type}: IProps) => {
    return (
        <></>
    )
}